import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Home from "./components/home/home";
import Dashboard from "./components/dashboard/dashboard";
import Login from "./components/dashboard/login";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/dashnow" element={<Dashboard />} />
        <Route path="/lognow" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
